// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"1f9e1d91","952":"8b748325"}[chunkId] + ".chunk.js";
};